// import { Row } from 'react-styled-flexboxgrid';

// export default Row;

import modal from 'antd/lib/modal';
import 'antd/lib/modal/style/css';

export default modal;
